import axios from "axios";
import { getBaseURL } from "../util/env";

// 쿠키에서 특정 쿠키 값을 가져오는 헬퍼 함수
// 매 요청마다 최신 쿠키 값을 읽기 위해 함수로 구현
const getCookie = (name) => {
  // document.cookie는 "name=value; name2=value2" 형식의 문자열
  const value = `; ${document.cookie}`;

  // 쿠키 문자열을 세미콜론과 공백으로 분리하여 배열로 만듦
  const parts = value.split(`; ${name}=`);
  // 해당 이름의 쿠키가 있으면 값 부분을 반환 (없으면 undefined)
  if (parts.length === 2) return parts.pop().split(";").shift();
  return undefined;
};

// 쿠키 설정 함수
const setCookie = (name, value, days = 7) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
};

// 로컬 개발 환경에서 테스트용 토큰 자동 설정
// 배포된 페이지에서 받아온 토큰 값 (테스트용)
const DEV_TEST_TOKEN =
  "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI5MDk2ODY2YS04ZjA1LTQ0YjUtYTc5MC05M2ZlMTJjMDc3ZTMiLCJhdXRob3JpdGllcyI6WyJST0xFX0lOVEVSTkFMX1VTRVIiXSwiY29tcGFueSI6IuuNsOydtO2EsOuplO2LsOy5tCIsInVzZXItbmFtZSI6Iu2Zqeyihe2YhCIsInVzZXItZW1haWwiOiJqb25naHl1bmh3YW5nQGRhdGFtYXRpY2Eua3IiLCJleHAiOjE3NzQ0NjI4NzN9.EWDe6CECpIHmzK8cjR120XdqqN8WcDtw8T61Pmz15oRm7ono8GDMtqYqACXgKv9ORo-U5qIc7nnaYy7hFYLnNQ";

// 로컬 개발 환경에서 쿠키가 없을 때 자동으로 테스트용 토큰 설정
const initializeDevToken = () => {
  // 개발 환경에서만 실행
  if (process.env.NODE_ENV !== "development") {
    return;
  }

  // access-token 쿠키가 없을 때만 설정
  const existingToken = getCookie("access-token");
  if (!existingToken) {
    console.log(
      "[개발 모드] access-token 쿠키가 없어 테스트용 토큰을 자동으로 설정합니다."
    );
    setCookie("access-token", DEV_TEST_TOKEN);
  }
};

// 앱 초기화 시 자동으로 실행
if (typeof window !== "undefined") {
  initializeDevToken();
}

const api = axios.create({
  // 프록시를 사용하므로 상대 경로 사용
  baseURL: process.env.REACT_APP_BASE_URL || "",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true,
});

// 요청 인터셉터 추가 - 매 요청마다 최신 토큰 사용
api.interceptors.request.use(
  (config) => {
    // 매 요청마다 쿠키를 읽어 최신 값을 사용
    const token = getCookie("access-token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
